<template>
    <v-app-bar :title="title" class="elevation-0"></v-app-bar>
</template>
<script>
export default {
  props: ['title']
}
</script>
